<template>
  <div v-if="carregaModel" :submit="ConsultaSerasa">
    <v-card>
      <v-row class="d-flex justify-center">
        <v-card-title class="text-h5 primary--text">Resultado da Consulta</v-card-title>
      </v-row>
      <v-row class="justify-end">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
              <v-btn label="teste" class="mr-3 mb-3" v-bind="attrs" v-on="on" depressed color="primary"
                @click="exportaBureauSerasa" data-cy="exportarPDF">
                <v-icon>ph-file-pdf</v-icon>
              </v-btn>
          </template>
          <span>Exportar PDF</span>
        </v-tooltip>
      </v-row>
      <v-card-text>
        <span class="text-h5 ml-3 primary--text">Dados da Consulta</span>
        <v-divider></v-divider>
        <SerasaPF v-if="model.SerasaPF" ref="SerasaPF" :model="model"></SerasaPF>
        <SerasaPJ v-if="model.SerasaPJ" ref="SerasaPJ" :model="model"></SerasaPJ>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {
    SerasaPF: () => import('./SerasaPF.vue'),
    SerasaPJ: () => import('./SerasaPJ.vue')
  },
  data () {
    return {
      model: {},
      carregaModel: false
    }
  },
  methods: {
    ConsultaSerasa (documento) {
      const th = this

      th.model = {}
      th.carregaModel = false

      var dto = {
        consulta: {
          Documento: documento
        }
      }
      th.$api.Bureau.ConsultaSerasa(th, dto).then((response) => {
        if (response.HasError || response.Falha || response.error) {
          th.$emit('error')
          th.$api.UI.ShowError('Erro', response.Msg || response.error)
        } else {
          th.$api.Bureau.FormataRetornoSerasa(th, response)
          th.carregaModel = true
        }
      })
    },
    exportaBureauSerasa (tipo) {
      const th = this
      var dto = {
        consulta: th.model
      }
      th.$api.Bureau.GerarPDFSerasa(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          th.downloadBureau(response.data, tipo)
        }
      })
    },
    downloadBureau (file, tipo) {
      var documentoModel = ''
      if (this.model.SerasaPJ) {
        documentoModel = this.model.SerasaPJ.DocumentoFederal
      } else {
        documentoModel = this.model.SerasaPF.DocumentoFederal
      }
      var nomeArquivo = 'Serasa - ' + documentoModel + '.pdf'
      var blob = tipo === 1 ? new Blob(['\ufeff', file], { type: 'text/csv' + ';charset=utf-8' }) : file;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
    }
  },
  computed: {
    isPessoaPF () {
      if (this.model.SerasaPF) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
